import { render, staticRenderFns } from "./Rating.vue.html?vue&type=template&id=04e942b5&scoped=true&"
import script from "./Rating.component.js?vue&type=script&lang=vueJs&"
export * from "./Rating.component.js?vue&type=script&lang=vueJs&"
import style0 from "./Rating.scoped.scss?vue&type=style&index=0&id=04e942b5&prod&lang=vueScss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e942b5",
  null
  
)

export default component.exports